import {
  WhitelabelDnsRecordPurpose,
  type WhitelabelExpectedDnsHost as GQLItem,
  type WhitelabelExpectedDnsRecord as GQLRecord,
} from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';

/** Keyed off the generated enum, so a backend rename is a compile error, not a dead comparison. */
export const DnsRecordPurpose = Object.freeze({
  TRAFFIC: WhitelabelDnsRecordPurpose.Traffic,
  CERTIFICATE_VALIDATION: WhitelabelDnsRecordPurpose.CertificateValidation,
});
export type DnsRecordPurpose = (typeof DnsRecordPurpose)[keyof typeof DnsRecordPurpose];

/** One DNS record a white-label client must create in their own zone. */
export type ExpectedDnsRecord = {
  role: string;
  name: string;
  type: string;
  target: string;
  dnsOnly: boolean;
  purpose: DnsRecordPurpose;
};

/** The records one client-facing host needs; `records` is empty and `error` says why when the host did not resolve. */
export type ExpectedDnsHost = {
  role: string;
  host?: string;
  error?: string;
  records: ExpectedDnsRecord[];
};

const recordFromGql = (item: GQLRecord): ExpectedDnsRecord =>
  take<ExpectedDnsRecord>(item, 'role', 'name', 'type', 'target', 'dnsOnly', 'purpose');

export const fromGql = (item: GQLItem): ExpectedDnsHost => ({
  ...take<ExpectedDnsHost>(item, 'role'),
  host: item.host ?? undefined,
  error: item.error ?? undefined,
  records: item.records.map(recordFromGql),
});

export const fromGqlCollection = (items: GQLItem[]): ExpectedDnsHost[] => items.map(fromGql);
